import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import CustomFormInput from './CustomFormInput';

export default class CustomRadioButtons extends CustomFormInput {
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {row: true})};
    }
    
    getElement() {
        let props       = this.getSupportedProps();
        props.row       = (typeof props.row == 'undefined' ? true : props.row);
        props.disabled  = this.props.disabled || false;

        return <RadioGroup onChange={this._onChange} {...props}>
                {_.map(this.props.options, option => <FormControlLabel key={'radio-' + option.value} control={<Radio />} disabled={props.disabled || false} {...option} />)}
            </RadioGroup>;
    }
}